import { useCallback, useEffect } from 'react'
import { useSearchParams } from 'react-router'

import { workspacePath, Workspace } from '@/true-fsd/data/advertiser-account'
import { useCopyToClipboard } from 'usehooks-ts'
import classes from '../LinksTable.module.scss'
// import { useActiveUser } from '@/true-fsd/data'

export type UseLinkToLinkArgs = {
    activeWorkspace: Workspace
    groupId: number
    link_id: number
}
export const useLinkToLink = ({ link_id, ...args }: UseLinkToLinkArgs) => {
    const trElementId = `link-${link_id}`

    useScrollToLink(trElementId)

    return useCopyLink(trElementId, args)
}

const useScrollToLink = (trElementId: string) => {
    const [searchParams] = useSearchParams()
    const shouldHighlight = searchParams.get('highlight') === trElementId

    useEffect(() => {
        if (shouldHighlight) {
            const el = document.getElementById(trElementId)

            if (el) {
                el.scrollIntoView({ block: 'center', behavior: 'smooth' })
                el.classList.add(classes.highlight)
            }
        }
    }, [shouldHighlight, trElementId])
}

const useCopyLink = (
    trElementId: string,
    {
        activeWorkspace,
        groupId,
    }: Pick<UseLinkToLinkArgs, 'activeWorkspace' | 'groupId'>
) => {
    // const { technician } = useActiveUser()

    const [, copy] = useCopyToClipboard()

    const path = workspacePath(activeWorkspace, `analytics/links/${groupId}`)
    const url = new URL(path, window.location.origin)
    url.searchParams.append('highlight', trElementId)
    const href = url.href

    const maybeCopyLinkToLinkToClipboard = useCallback(() => {
        // if (technician) {
        void copy(href)
        // }
    }, [
        copy,
        href,
        // technician
    ])

    return {
        trElementId,
        maybeCopyLinkToLinkToClipboard,
    }
}
